/* RH Produkt-Template: 'mehr lesen'-Kollaps der rh-pd-Beschreibung.
   11.09.2026: Bei kurzem Text (passt ohne Kuerzung in die Karte) bekommt die Karte
   die Klasse is--kurz -> kein Grauverlauf, keine max-height, kein Knopf. Die Pruefung
   laeuft erneut nach dem Laden der Schriften, der Bilder und bei Groessenaenderung,
   weil sich die Texthoehe dabei aendert (vorher: Verlauf blieb ohne Knopf stehen). */
(function () {
  var haupt = document.querySelector('.rh-pd-haupt');
  var btn = document.querySelector('.rh-pd-mehr');
  if (!haupt || !btn || btn.dataset.rhInit) return;
  btn.dataset.rhInit = '1';
  var sync = function () {
    if (!haupt.classList.contains('is--zu')) return; /* aufgeklappt: nichts tun */
    haupt.classList.remove('is--kurz');
    var abgeschnitten = haupt.scrollHeight > haupt.clientHeight + 4;
    btn.style.display = abgeschnitten ? '' : 'none';
    haupt.classList.toggle('is--kurz', !abgeschnitten);
  };
  btn.addEventListener('click', function () {
    var zu = haupt.classList.toggle('is--zu');
    btn.classList.toggle('is--offen', !zu);
    btn.querySelector('.rh-pd-mehr-txt').textContent = zu ? btn.dataset.mehr : btn.dataset.weniger;
    if (zu) haupt.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
  sync();
  window.addEventListener('load', sync);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sync, 150); });
})();
